import React from 'react'
import SilverButton from "../../../../../../components-new/buttons/SilverButton";
import ChevronLeftIcon from "../../../../../../assets/icons/ChevronLeftIcon";
import Popup from "../../../../../../components-new/ui/Popup";
import InfoIcon from "../../../../../../assets/icons/InfoIcon";
import './styles.css'
import colors from "../../../../../../utils/Colors";
import {withRouter} from 'react-router-dom';
import HandIcon from "../../../../../../assets/icons/HandIcon";
import Translate from "../../../../../../components/Translate";
import Accordion from "../../../../../../components-new/ui/Accordion";
import AccordionItem from "../../../../../../components-new/ui/Accordion/AccordionItem";

const GraphActions = ({history}) => {

    const [infoOpen, setInfoOpen] = React.useState(false);

    const handleBackClick = () => {
        history.push('/dashboard/management/clients');
    };

    return (
        <div className="graph-actions">

            <div className={`instructions-container ${infoOpen ? 'open' : ''}`}>
                <div className="instruction-row">
                    <HandIcon className="instruction-icon" height={18} width={18}/>
                    <span>-</span>
                    <span className="instruction-text"><Translate text={'treeDragDescription'} /></span>
                </div>

                <div className="instruction-row">
                    <span className="instruction-key">Scroll</span>
                    <span>-</span>
                    <span className="instruction-text"><Translate text={'treeZoomDescription'} /></span>
                </div>

                <div className="instruction-row">
                    <span className="instruction-key">Shift</span>
                    <span>+</span>
                    <span className="instruction-key">Scroll</span>
                    <span>-</span>
                    <span className="instruction-text"><Translate text={'treeShiftDescription'} /></span>
                </div>
            </div>

            <div className="graph-actions-container">
                <div className="graph-actions-container-item">
                    <SilverButton
                        styles={{
                            height: '40px',
                            padding: '10px',
                        }}
                        onClick={handleBackClick}
                    >
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: '6px',
                            color: colors.silverBlueDark,
                            fontSize: 14
                        }}>
                            <ChevronLeftIcon style={{color: colors.silverBlueDark}} stroke="currentColor" width={16} height={16}/>
                            <Translate text={'back'}/>
                        </div>
                    </SilverButton>
                </div>

                <div className="graph-actions-container-item">
                    <SilverButton
                        styles={{
                            height: '40px',
                            padding: '10px',
                        }}
                        onClick={() => setInfoOpen(prev => !prev)}
                    >
                        <InfoIcon style={{color: colors.silverBlueDark}} stroke="currentColor" width={18} height={18}/>
                    </SilverButton>
                </div>
            </div>

        </div>
    );
};


export default withRouter(GraphActions);


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphActions/index.jsx